import React from 'react';
import { 
    AssessmentContainer, 
    AssessmentBody, 
    AssessmentContent, 
    AssessmentFooter,
    AssessmentContentHeader,
    AssessmentContentAction,
    AssessmentContentActionButton
} from '../../../assessment/common';

import { isMobile } from 'react-device-detect';


const DemoContainer = ({children, onBackClick = undefined, onNextClick = undefined, footerExtra, label, includeProgress, copyrightChild, title = "", overrideLogo = true, overrideVersion = false}) => (
    <AssessmentContainer>
        <AssessmentContentHeader><span>{title}</span></AssessmentContentHeader> 
        <AssessmentBody style={{padding: '0 10%'}}>
            <AssessmentContent className="demo-content">
                {children}
            </AssessmentContent>
        </AssessmentBody>
        <AssessmentContentAction>
            <AssessmentContentActionButton styleType='arrows' onClick={onBackClick}>{"<"}</AssessmentContentActionButton>
            <AssessmentContentActionButton styleType='arrows' onClick={onNextClick}>{">"}</AssessmentContentActionButton>
        </AssessmentContentAction>
        <AssessmentFooter label={label} includeVersion={overrideVersion} includeProgress={includeProgress} copyrightChild={copyrightChild} includeLogo={overrideLogo} /*label={"DEMOGRAPHICS" + (footerExtra !== "" && footerExtra !== undefined ? " - " + footerExtra : "")}*/></AssessmentFooter>
    </AssessmentContainer>
)

export default DemoContainer;